var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"account_content",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"custom_flex_title",attrs:{"xs12":""}},[_c('h3',[_vm._v("Mon profil")])]),_c('v-flex',{attrs:{"xs12":""}},[_c('account-profil')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }